import type { IPipelineEvent } from '../type';

/** Display label derived from event type (e.g. GR, Check-in). */
export const getEventTypeLabel = (type: string): string => {
  if (type === 'gr_meeting') {
    return 'GR';
  }
  if (type === 'checkin_meeting' || type === 'check_in') {
    return 'Check-in';
  }
  return '';
};

export const getEventCardPrimaryLabel = (evt: IPipelineEvent): string => {
  return evt.milestone || '/';
};

export const getEventCardTypeSuffix = (evt: IPipelineEvent): string => {
  return getEventTypeLabel(evt.type);
};

/** True when the event has displayable content (non-placeholder). */
export const hasPipelineEventContent = (evt: IPipelineEvent): boolean => {
  return !!evt.milestone;
};
